
/*
 *   File : kyc-status.js
 *   Author URI : https://evoqins.com
 *   Description : Fetch data from digi locker.
 *   Integrations : null
 *   Version : v1.1
 */
import { useState, useRef, useEffect, Fragment } from "react";
import { parse, format } from 'date-fns';
import Cookies from 'js-cookie';


import { GradientButton, OutlineButton } from "../../../Component/CTA";
import { CustomFilePicker, CustomPhoneInput, CustomSelectBox, CustomTextInput, DatePicker, FilePreview, RadioGroup } from "../../../Component/Form-elements";
import Icon from "../../../Component/Icon/icon";
import APIService from "../../../Service/api-service";
import { toast } from "react-toastify";
import { _uploadDocumentToS3 } from "../../../Service/aws-service";
import { _convertToLabelIdArray, _isFileTypeAllowed } from "../../../Helper";
import { _getKycProfile } from "../../../Helper/api";
import { useSelector } from "react-redux";
import { CustomLoader } from "../../../Component/Other";
import { useLocation, useNavigate } from "react-router-dom";
import Store from "../../../Store";

const KYC_DATA = [{
    id: 1,
    label: "Proceed with existing details"
},
{
    id: 2,
    label: "Update details using Digilocker"
}]

export default function KYCStatusPage(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const PROGRESS_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA);
    const KIRA_INFO = useSelector(state => state.generalData.KYC_PROGRESS_DATA.kra_info);
    const GENERAL_DATA = useSelector(state => state.generalData.KYC_GENERAL_DATA);
    const validationRef = useRef([]);
    const detailsRef = useRef(null);
    const maxDate = new Date();
    const [apiLoader, setApiLoader] = useState(false);
    const [kycCompleted, setKycCompleted] = useState(false);
    const [selected_kyc, setselected_kyc] = useState(KYC_DATA[0].id);
    const [kycCompleteData, setKycCompletedData] = useState({});
    const [loader, setLoader] = useState(true);
    const [isAddressUpdated, setIsAddressUpdated] = useState(false);
    maxDate.setFullYear(maxDate.getFullYear() - 18);

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [panNumber, setPanNumber] = useState("");
    const [panNumberError, setPanNumberError] = useState("");

    const [dob, setdob] = useState(null);
    const [dobError, setDobError] = useState("");

    const [mail, setMail] = useState('');
    const [mailError, setMailError] = useState('');

    const [phone, setPhone] = useState('');
    const [phoneError, setPhoneError] = useState("");

    const [uploadedPan, setUploadedPan] = useState(null);
    const [panUrl, setPanUrl] = useState(null);
    const [uploadedPanError, setUploadedPanError] = useState("");
    const [fileLoader, setFileLoader] = useState(false);

    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine1Error, setAddressLine1Error] = useState('');

    const [addressLine2, setAddressLine2] = useState('');
    const [addressLine2Error, setAddressLine2Error] = useState('');

    const [addressLine3, setAddressLine3] = useState('');
    const [addressLine3Error, setAddressLine3Error] = useState('');

    const [addressCountry, setAddressCountry] = useState(null);
    const [addressCountryError, setAddressCountryError] = useState("");
    const [addressState, setAddressState] = useState(null);
    const [addressStateError, setAddressStateError] = useState("");
    const [addressCity, setAddressCity] = useState(null);
    const [addressCityError, setAddressCityError] = useState("");

    const [pinCode, setPinCode] = useState('');
    const [pinCodeError, setPinCodeError] = useState('');

    const [addressProof, setAddressProof] = useState(null);
    const [addressProofOptions, setAddressProofOptions] = useState(null);
    const [addressProofError, setAddressProofError] = useState("");

    const [addressUploadedProof, setAddressUploadedProof] = useState(null);
    const [addressProofUrl, setAddressProofUrl] = useState(null);
    const [addressUploadedProofError, setAddressUploadedProofError] = useState(null);

    const [countryOption, setCountryOptions] = useState([]);

    const [stateOption, setStateOptions] = useState([]);
    const [cityOption, setCityOptions] = useState([]);

    const [stateOption1, setStateOptions1] = useState([]);
    const [cityOption1, setCityOptions1] = useState([]);

    const [btnLoader, setBtnLoader] = useState(false);
    const [maritalData, setMaritalData] = useState(_convertToLabelIdArray(GENERAL_DATA?.marital_status ?? []) ?? []);
    const [genderData, setGenderData] = useState(_convertToLabelIdArray(GENERAL_DATA?.gender ?? []) ?? []);

    const [occupationList, setOccupationList] = useState([]);
    const [incomeList, setIncomeList] = useState([]);

    const [kartaFatherName, setkartaFatherName] = useState("");
    const [kartaFatherNameError, setKartaFatherNameError] = useState("");
    const [kartaMotherName, setKartaMotherName] = useState("");
    const [kartaMotherNameError, setKartaMotherNameError] = useState("");
    const [kartaGender, setkartaGender] = useState(genderData[0]?.id);
    const [kartaGenderError, setKartaGenderError] = useState("");
    const [kartaMaritalStatus, setKartaMartalStatus] = useState(maritalData[0]?.id);
    const [kartMaritalStatusError, setKartaMaritalStatusError] = useState("");
    const [kartaOccupation, setKartaOccupation] = useState("");
    const [kartaOccupationError, setKartaOccupationError] = useState("");
    const [kartaOtherOccupation, setKartaOtherOccupation] = useState("");
    const [kartaOtherOccupationError, setKartaOtherOccupationError] = useState("");
    const [kartaIncome, setKartaIncome] = useState("");
    const [kartaIncomeError, setkartaIncomeError] = useState("");
    const [coparcenerDetails, setCoparcenerDetails] = useState([
        {
            name: "",
            nameError: "",
            panNumber: "",
            panNumberError: "",
            dob: null,
            dobError: "",
            mail: "",
            mailError: "",
            phone: "",
            phoneError: "",
            fatherName: "",
            fatherNameError: "",
            motherName: "",
            motherNameError: "",
            gender: genderData[0]?.id,
            maritalStatus: maritalData[0]?.id,
            uploadedPan: null,
            panUrl: "",
            uploadedPanError: "",
            addressLine1: "",
            addressLine1Error: "",
            addressLine2: "",
            addressLine2Error: "",
            addressLine3: "",
            addressLine3Error: "",
            addressState: null,
            addressStateError: "",
            addressCity: null,
            addressCityError: "",
            addressCountry: null,
            addressCountryError: "",
            pinCode: "",
            pinCodeError: "",
            addressProof: null,
            addressProofError: "",
            addressUploadedProof: null,
            addressProofUrl: "",
            addressUploadedProofError: ""
        }
    ])


    useEffect(() => {
        setKycCompletedData(KIRA_INFO);
        setKycCompleted(KIRA_INFO.kyc_compliant);
        setLoader(false)
    }, [])

    useEffect(() => {
        if (GENERAL_DATA) {
            let occ = GENERAL_DATA?.occupation.map((item) => {
                return (
                    { value: item.id, label: item.name }
                )
            });
            setOccupationList(occ);
            let income = GENERAL_DATA?.income_slab.map((item) => {
                return (
                    { value: item.id, label: item.name }
                )
            });
            setIncomeList(income);
        }
    }, [GENERAL_DATA]);

    useEffect(() => {
        _getCountries();
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const status = params.get("status"); // success / failure
        if (status) {
            // navigate("/kyc")
            // _digiLockerCallback();
        }
    }, []);


    useEffect(() => {
        if (Object.keys(GENERAL_DATA).length > 0) {

            const address_proof = GENERAL_DATA?.cams_kyc_proof?.length > 0 && GENERAL_DATA?.cams_kyc_proof?.map((item) => {
                return ({
                    label: item.name,
                    value: item.id
                })
            })
            setAddressProofOptions(address_proof);
            // setSelectedAccountType(sub_types[0].id);
        }
    }, [GENERAL_DATA]);

    useEffect(() => {
        const huf_details = PROGRESS_DATA.huf_info;

        setName(huf_details.karta_name !== null ? huf_details.karta_name : '');
        setPanNumber(huf_details.karta_pan !== null ? huf_details.karta_pan : '');
        if (huf_details.karta_dob !== null) {
            setdob(_getFormattedDob(huf_details.karta_dob));
        } else {
            setdob(null)
        }
        setMail(huf_details.karta_email !== null ? huf_details.karta_email : "");
        setPhone(huf_details.karta_mobile !== null ? huf_details.karta_mobile : "");
        setAddressLine1(huf_details.karta_address_line_1 !== null ? huf_details.karta_address_line_1 : "");
        setAddressLine2(huf_details.karta_address_line_2 !== null ? huf_details.karta_address_line_2 : "");
        setAddressLine3(huf_details.karta_address_line_3 !== null ? huf_details.karta_address_line_3 : "");
        setkartaFatherName(huf_details.karta_father_name !== null ? huf_details.karta_father_name : "");
        setKartaMotherName(huf_details.karta_mother_name !== null ? huf_details.karta_mother_name : "");
        setKartaOtherOccupation(huf_details.karta_other_occupation !== null ? huf_details.karta_other_occupation : "");
        if (huf_details.karta_occupation_id !== null) {
            setKartaOccupation({ value: huf_details.karta_occupation_id, label: huf_details.karta_occupation })
        }
        if (huf_details.karta_gender_id !== null) {
            setkartaGender(huf_details.karta_gender_id);
        }
        if (huf_details.karta_income_id !== null) {
            setKartaIncome({ value: huf_details.karta_income_id, label: huf_details.karta_income });
        }
        if (huf_details.karta_marital_status_id !== null) {
            setKartaMartalStatus(huf_details.karta_marital_status_id);
        }
        setPinCode(huf_details.karta_pincode !== null ? huf_details.karta_pincode : "");
        if (huf_details.karta_country_id) {
            setAddressCountry({
                label: huf_details.karta_country,
                value: huf_details.karta_country_id
            })
            _getStates(huf_details.karta_country_id, 1)
        }
        if (huf_details.karta_state_id !== null) {
            setAddressState({
                label: huf_details.karta_state,
                value: huf_details.karta_state_id
            })
            _getCities(huf_details.karta_state_id, 1);
        }
        if (huf_details.karta_city_id !== null) {
            setAddressCity({
                label: huf_details.karta_city,
                value: huf_details.karta_city_id
            });
        }
        if (huf_details.karta_proof_id) {
            setAddressProof({
                label: huf_details.karta_proof_type,
                value: huf_details.karta_proof_id
            });
        }
        if (PROGRESS_DATA.karta_pan_url !== null) {
            setPanUrl(PROGRESS_DATA?.karta_pan_url);
            setUploadedPan(_getFileName(PROGRESS_DATA?.karta_pan_url));
        }

        if (huf_details.karta_proof_url !== null) {
            setAddressProofUrl(huf_details.karta_proof_url)

            setAddressUploadedProof(_getFileName(huf_details.karta_proof_url));
        }

        if (huf_details.coparcener.length > 0) {
            const copencer_details = []
            huf_details.coparcener.map((item) => {
                _getStates(item.coparcener_country_id, 2)
                _getCities(item.coparcener_state_id, 2)
                return (
                    copencer_details.push({
                        name: item.coparcener_name !== null ? item.coparcener_name : "",
                        nameError: "",
                        panNumber: item.coparcener_pan !== null ? item.coparcener_pan : "",
                        panNumberError: "",
                        dob: item.coparcener_dob !== null ? _getFormattedDob(item.coparcener_dob) : item.coparcener_dob,
                        dobError: "",
                        mail: item.coparcener_email !== null ? item.coparcener_email : "",
                        mailError: "",
                        phone: item.coparcener_mobile !== null ? item.coparcener_mobile : "",
                        phoneError: "",
                        uploadedPan: item.coparcener_pan_url !== null ? _getFileName(item.coparcener_pan_url) : null,
                        uploadedPanError: "",
                        panUrl: item.coparcener_pan_url !== null ? item.coparcener_pan_url : "",
                        addressLine1: item.coparcener_address_line_1 !== null ? item.coparcener_address_line_1 : "",
                        addressLine1Error: "",
                        addressLine2: item.coparcener_address_line_2 !== null ? item.coparcener_address_line_2 : "",
                        addressLine2Error: "",
                        addressLine3: item.coparcener_address_line_3 !== null ? item.coparcener_address_line_3 : "",
                        addressLine3Error: "",
                        addressCountry: item.coparcener_country_id !== null ? {
                            label: item.coparcener_country,
                            value: item.coparcener_country_id
                        } : null,
                        addressState: item.coparcener_state_id !== null ? {
                            label: item.coparcener_state,
                            value: item.coparcener_state_id
                        } : null,
                        addressCity: item.coparcener_city_id !== null ? {
                            label: item.coparcener_city,
                            value: item.coparcener_city_id
                        } : null,
                        pinCode: item.coparcener_pincode !== null ? item.coparcener_pincode : "",
                        pinCodeError: "",
                        fatherName: item.coparcener_father_name ? item.coparcener_father_name : "",
                        fatherNameError: "",
                        motherName: item.coparcener_mother_name ? item.coparcener_mother_name : "",
                        motherNameError: "",
                        gender: item.coparcener_gender_id ? item.coparcener_gender_id : genderData[0]?.id,
                        maritalStatus: item.coparcener_marital_status_id ? item.coparcener_marital_status_id : maritalData[0]?.id,
                        addressProof: item.coparcener_proof_id !== null ? {
                            label: item.coparcener_proof_type,
                            value: item.coparcener_proof_id
                        } : null,
                        addressUploadedProof: item.coparcener_proof_url !== null ? _getFileName(item.coparcener_proof_url) : null,
                        addressProofUrl: item.coparcener_proof_url !== null ? item.coparcener_proof_url : "",
                        addressUploadedProofError: ""
                    })
                )
            })
            setCoparcenerDetails(copencer_details)

        }


    }, [PROGRESS_DATA])

    function _handleButtonClick() {
        props.updateProgress(4, props.text, props.is_manual);
    }

    function _getFileName(url) {
        const decodedURL = decodeURIComponent(decodeURIComponent(url));
        const fileName = decodedURL.split('?')[0].split("/").pop();
        return fileName
    }

    function _getFormattedDob(date) {
        const parsed_date = parse(date, 'dd-MM-yyyy', new Date());
        const formatted_date = format(parsed_date, 'dd/MM/yyyy');
        return formatted_date
    }

    // name handler
    function _handleName(input_value) {
        setName(input_value);
        setNameError("");
    }

    // PAN handler
    function _handlePan(input_value) {
        setPanNumber(input_value);
        setPanNumberError("");
    }

    // DOB handler
    function _handleDob(date) {
        setdob(date);
        setDobError("");
    }

    // mail handler 
    function _handleMail(input_value) {
        setMail(input_value);
        setMailError(null);
    }

    // mobile handler
    function _handlePhone(input_value) {
        setPhoneError("");
        setPhone(input_value);
    }

    // karta father name
    function _handleKartaFatherName(input) {
        setKartaFatherNameError("");
        setkartaFatherName(input);
    }

    // karta mother name
    function _handleKartaMotherName(input) {
        setKartaMotherNameError("");
        setKartaMotherName(input);
    }


    // karta gender 
    function _handleKartaGender(id) {
        setKartaGenderError("");
        setkartaGender(id);
    }

    // karta marital status
    function _handleKartaMaritalStatus(id) {
        setKartaMaritalStatusError("");
        setKartaMartalStatus(id);
    }

    // handle pan upload
    function _handlePanUpload(path, file) {
        // eslint-disable-next-line
        var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setUploadedPanError("");
                    setFileLoader(1);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(1);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setPanUrl(response.data.view_info); // file got uploaded successfully
                                setFileLoader(false);
                                setUploadedPan(file_formatted);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setUploadedPanError("File size should be less than 5mb");
                }
            }
            else {
                setUploadedPanError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }


    function _handleUploadFile(path, file) {
        // eslint-disable-next-line
        // var file_formatted = file.replace(/^.*[\\\/]/, '').split('/');
        // setAddressUploadedProof(file_formatted);

        var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setAddressUploadedProofError("");
                    setFileLoader(2);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(2);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setAddressProofUrl(response.data.view_info); // file got uploaded successfully
                                setFileLoader(false);
                                setAddressUploadedProof(file_formatted);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setAddressUploadedProofError("File size should be less than 5mb");
                }
            }
            else {
                setAddressUploadedProofError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    };

    function _handleCopencerDetails(input_value, index, key, error) {
        const copencer_details = [...coparcenerDetails]
        copencer_details[index][`${key}`] = input_value
        if (error) {
            copencer_details[index][`${error}`] = ""
        }
        setCoparcenerDetails(copencer_details)
    };

    function _handleCopencerFileUpload(path, file, index, key, error, url) {
        // eslint-disable-next-line
        // var file_formatted = file.replace(/^.*[\\\/]/, '').split('/');
        const copencer_details = [...coparcenerDetails]
        // copencer_details[index][`${key}`] = file_formatted
        // copencer_details[index][`${error}`] = ""
        // setCoparcenerDetails(copencer_details)

        if (path !== "") {
            var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
            file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
            const parts = file_formatted.split('.');
            if (parts.length > 1) {
                const extension = '.' + parts.pop();
                if (_isFileTypeAllowed(extension)) {
                    // checking if file size is greater than 5mb
                    const file_size = 5 * 1024 * 1024
                    if (file.size < file_size) {
                        copencer_details[index][`${error}`] = ""
                        setFileLoader(`${key}${index}`);
                        let api_url = "general/file-upload";
                        let body = {
                            "key": `support/${file_formatted}`
                        }

                        APIService(true, api_url, body).then((response) => {
                            if (response.status_code === 200) {
                                setFileLoader(`${key}${index}`);

                                // s3 helper
                                _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                    copencer_details[index][`${url}`] = (response.data.view_info); // file got uploaded successfully
                                    setFileLoader(false);
                                    copencer_details[index][`${key}`] = file_formatted
                                }).catch(error => {
                                    toast.dismiss();
                                    toast.error(error, {
                                        type: "error",
                                    });
                                    setFileLoader(false);
                                });

                            } else {
                                setFileLoader(false);
                                toast.dismiss();
                                toast.error(response, {
                                    type: "error",
                                });
                            }
                        })
                    } else {
                        copencer_details[index][`${error}`] = ("File size should be less than 5mb");
                    }
                }
                else {
                    copencer_details[index][`${error}`] = ("File type should be .pdf, .jpeg, .jpg, .png");
                }
            }
        } else {
            copencer_details[index][`${error}`] = ""
            copencer_details[index][`${url}`] = ""
            copencer_details[index][`${key}`] = null
        }
        setCoparcenerDetails(copencer_details)
    };

    function _handleAddDetails() {
        const copencer_details = [...coparcenerDetails]
        copencer_details.push({
            name: "",
            nameError: "",
            panNumber: "",
            panNumberError: "",
            dob: null,
            dobError: "",
            mail: "",
            mailError: "",
            phone: "",
            phoneError: "",
            uploadedPan: null,
            panUrl: "",
            uploadedPanError: "",
            addressLine1: "",
            addressLine1Error: "",
            addressLine2: "",
            addressLine2Error: "",
            addressLine3: "",
            addressLine3Error: "",
            addressState: null,
            addressStateError: "",
            addressCity: null,
            addressCityError: "",
            addressCountry: null,
            addressCountryError: "",
            pinCode: "",
            pinCodeError: "",
            addressProof: null,
            addressProofError: "",
            addressUploadedProof: null,
            addressProofUrl: "",
            addressUploadedProofError: "",
            fatherName: "",
            fatherNameError: "",
            motherName: "",
            motherNameError: "",
            gender: genderData[0].id,
            maritalStatus: maritalData[0].id,
        });
        setCoparcenerDetails(copencer_details)
    }

    function _handleDelete(index) {
        const copencer_details = [...coparcenerDetails];
        copencer_details.splice(index, 1);
        setCoparcenerDetails(copencer_details);
    }

    function _handleValidation() {
        let valid_form = true;
        // eslint-disable-next-line
        let is_scrolled = false;
        const copencer_details = [...coparcenerDetails]
        copencer_details.forEach((element, index) => {
            if (element.name.length < 3) {
                element.nameError = ("Enter valid name");
                valid_form = false;
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.phone.length < 10) {
                element.phoneError = ("Enter valid phone");
                valid_form = false;
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.dob === null) {
                element.dobError = ("Enter date of birth");
                valid_form = false;
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.panNumber !== "" && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(element.panNumber)) {
                valid_form = false;
                element.panNumberError = ("Enter valid pan number");
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            // if (element.uploadedPan === null) {
            //     valid_form = false;
            //     element.uploadedPanError = ('Upload file');
            //     validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
            //     is_scrolled = true;
            // }
            if (element.fatherName === '') {
                valid_form = false;
                element.fatherNameError = ('Father name is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.motherName === '') {
                valid_form = false;
                element.motherNameError = ('Monther name is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.mail === '') {
                valid_form = false;
                element.mailError = ('Required field');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.mail !== '' && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(element.mail)) {
                element.mailError = ('Invalid email');
                valid_form = false;
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }

            if (element.addressLine1.length === 0) {
                valid_form = false;
                element.addressLine1Error = ('Address line1 is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            // if (element.addressLine2.length === 0) {
            //     valid_form = false;
            //     element.addressLine2Error = ('Address line2 is required');
            //     validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
            //     is_scrolled = true;
            // }
            // if (element.addressLine3.length === 0) {
            //     valid_form = false;
            //     element.addressLine3Error = ('Address line3 is required');
            //     validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
            //     is_scrolled = true;
            // }
            if (element.addressCountry === null) {
                valid_form = false;
                element.addressCountryError = ('Country is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.addressState === null) {
                valid_form = false;
                element.addressStateError = ('State is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.addressCity === null) {
                valid_form = false;
                element.addressCityError = ('City is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.pinCode.length === 0) {
                valid_form = false;
                element.pinCodeError = ('Pin code in required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.pinCode.length !== 0 && element.pinCode.length !== 6) {
                valid_form = false;
                element.pinCodeError = ('Invalid pin code');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.addressProof === null) {
                valid_form = false;
                element.addressProofError = ('Proof type is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
            if (element.addressUploadedProof === null) {
                valid_form = false;
                element.addressUploadedProofError = ('Proof is required');
                validationRef.current[index].scrollIntoView({ block: "start", behavior: "smooth" });
                is_scrolled = true;
            }
        })
        setCoparcenerDetails(copencer_details)
        if (name.length < 3) {
            setNameError("Enter valid name");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        }
        if (phone.length < 10) {
            setPhoneError("Enter valid phone");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        }
        if (dob === null) {
            setDobError("Enter date of birth");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        }
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNumber)) {
            valid_form = false;
            setPanNumberError("Enter valid pan number");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (uploadedPan === null) {
            valid_form = false;
            setUploadedPanError('Upload file');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (kartaFatherName.length < 3) {
            setKartaFatherNameError("Enter valid father name");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        }
        if (kartaMotherName.length < 3) {
            setKartaMotherNameError("Enter valid mother name");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        }
        if (kartaOccupation === "") {
            setKartaOccupationError("Select Karta occupation");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        } else {
            if (kartaOccupation.value === 116 && kartaOtherOccupation.length === 0) {
                setKartaOtherOccupationError("Enter valid occupation");
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
                valid_form = false;
            }
        }

        if (kartaIncome.length === 0) {
            setkartaIncomeError("Select karta income");
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        }

        if (mail === '') {
            valid_form = false;
            setMailError('Required field');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (mail !== '' && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(mail)) {
            setMailError('Invalid email');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            valid_form = false;
        }

        if (addressLine1.length === 0) {
            valid_form = false;
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            setAddressLine1Error('Address line1 is required');
        }
        // if (addressLine2.length === 0) {
        //     valid_form = false;
        //     setAddressLine2Error('Address line2 is required');
        //     detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        // }
        // if (addressLine3.length === 0) {
        //     valid_form = false;
        //     setAddressLine3Error('Address line3 is required');
        //     detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        // }
        if (addressCountry === null) {
            valid_form = false;
            setAddressCountryError('Country is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (addressState === null) {
            valid_form = false;
            setAddressStateError('State is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (addressCity === null) {
            valid_form = false;
            setAddressCityError('City is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (pinCode.length === 0) {
            valid_form = false;
            setPinCodeError('Pin code in required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (pinCode.length !== 0 && pinCode.length !== 6) {
            valid_form = false;
            setPinCodeError('Invalid pin code');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (addressProof === null) {
            valid_form = false;
            setAddressProofError('Proof type is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (addressUploadedProof === null) {
            valid_form = false;
            setAddressUploadedProofError('Proof is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }

        if (valid_form === true) {
            _addHufDetails();
        }
    }

    // API - get countries
    const _getCountries = () => {
        const url = "general/countries";

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                const countries = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.country_id
                    })
                })
                setCountryOptions(countries);
            }
        })
    }

    // API - get countries
    const _getStates = (id, type) => {
        const url = "general/states";

        const data = {
            "country_id": Number(id)
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                const states = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.state_id
                    })
                })

                if (type === 1) {
                    setStateOptions(states);
                } else {
                    setStateOptions1(states);
                }
            } else {
                if (type === 1) {
                    setStateOptions([]);
                } else {
                    setStateOptions1([]);
                }
            }
        })
    }

    // API - get cities
    const _getCities = (id, type) => {
        const url = "general/cities";

        const data = {
            "state_id": Number(id)
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                const cities = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.city_id
                    })
                })
                if (type === 1) {
                    setCityOptions(cities);
                } else {
                    setCityOptions1(cities);
                }

            } else {
                if (type === 1) {
                    setCityOptions([]);
                } else {
                    setCityOptions1([]);
                }

            }
        })
    }

    // API - add huf details
    const _addHufDetails = () => {
        setBtnLoader(true);
        const url = "kyc/add-huf-details";
        const copencer_details = coparcenerDetails.map((item) => {
            return ({
                "coparcener_name": item.name,
                "coparcener_email": item.mail,
                "coparcener_mobile": item.phone,
                "coparcener_dob": item.dob,
                "coparcener_pan": item.panNumber,
                "coparcener_address_line_1": item.addressLine1,
                "coparcener_address_line_2": item.addressLine2,
                "coparcener_address_line_3": item.addressLine3,
                "coparcener_pincode": item.pinCode,
                "coparcener_pan_url": item.panUrl,
                "coparcener_city_id": item.addressCity.value,
                "coparcener_state_id": item.addressState.value,
                "coparcener_country_id": item.addressCountry.value,
                "coparcener_proof_url": item.addressProofUrl,
                "coparcener_father_name": item.fatherName,
                "coparcener_mother_name": item.motherName,
                "coparcener_marital_status_id": item.maritalStatus,
                "coparcener_gender_id": item.gender,
                "coparcener_proof_id": item.addressProof.value
            })
        })
        const data = {
            "karta_name": name,
            "is_review": props.edit,
            "karta_email": mail,
            "karta_mobile": phone,
            "karta_pan": panNumber,
            "karta_dob": dob,
            "karta_address_line_1": addressLine1,
            "karta_address_line_2": addressLine2,
            "karta_address_line_3": addressLine3,
            "karta_pincode": pinCode,
            "karta_pan_url": panUrl,
            "karta_city_id": addressCity.value,
            "karta_state_id": addressState.value,
            "karta_country_id": addressCountry.value,
            "karta_proof_id": addressProof.value,
            "karta_proof_url": addressProofUrl,
            "karta_father_name": kartaFatherName,
            "karta_mother_name": kartaMotherName,
            "karta_gender_id": kartaGender,
            "karta_marital_status_id": kartaMaritalStatus,
            "karta_occupation_id": kartaOccupation?.value,
            "karta_other_occupation": kartaOtherOccupation,
            "karta_income_id": kartaIncome?.value,
            "coparcener_details": copencer_details
        }

        APIService(true, url, data).then((response) => {
            toast.dismiss()
            if (response.status_code === 200) {
                toast.success("HUF details added successfully");
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                props.updateProgress(response.kyc_data.is_review ? 8 : 4, props.text, props.is_manual)
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setBtnLoader(false)
        })
    }


    // API - initiate digilocker to get address
    function _getAddressFromAadhar() {
        setApiLoader(true);
        let url = 'kyc/digilocker/initiate';
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                // setDigilockerData(response.data);
                _initiateDigiLocker(response.data.id, response.data.customer_identifier, response.data.access_token.id);
                Cookies.set('digio_token', response.data.access_token.id);

            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
                setApiLoader(false);
            }
        })
        // props.updateProgress(4);
    }

    async function _initiateDigiLocker(digiLockerId, mail, token_id) {
        try {
            // Use sandbox/test URL
            const baseUrl = process.env.REACT_APP_DIGILOCKER_ENVIRONMENT === "production" ? "https://app.digio.in/#/gateway/login" : "https://ext-gateway.digio.in/#/gateway/login"

            const sdkver = "11.0";
            const method = "otp";
            const redirect_timeout = 2800;

            const theme = encodeURIComponent(
                JSON.stringify({
                    PRIMARY_COLOR: "#2979BF",
                    FONT_FAMILY: "",
                    FONT_URL: "",
                    FONT_FORMAT: "",
                })
            );

            const redirectUrl = encodeURIComponent(
                window.location.origin + "/digio-callback?verification-type=address"
            );

            const url = `${baseUrl}/${digiLockerId}/${token_id}/${mail}?token_id=${token_id}&sdkver=${sdkver}&method=${method}&redirect_timeout=${redirect_timeout}&theme=${theme}&redirect_url=${redirectUrl}`;

            // Open in a new tab / page
            window.location.href = (url);
        } catch (err) {
            console.error("Unable to open DigiLocker page", err);
        }
    }


    // API - save address
    const _saveAddress = async () => {
        let url = 'kyc/save-address';
        try {
            const response = await APIService(false, url);
            if (response.status_code === 200) {
                // const kyc_data = await _getKycProfile();
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                // props.updateProgress(4);
                props.updateProgress(response.kyc_data.is_review ? 8 : 4)
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                });
            }
        } catch (error) {
            toast.dismiss();
            toast.error(error.message, {
                type: "error",
            });
        } finally {
            setApiLoader(false);
        }
    };


    const _handleRadioInput = (e) => {
        setselected_kyc(e)
    }

    const _handleProceed = () => {
        setApiLoader(true);
        switch (selected_kyc) {
            case 1:
                _saveAddress();
                break;

            case 2: if (isAddressUpdated === true) {
                props.updateProgress(4);
            } else {
                _getAddressFromAadhar();
            }

                break;
        }
    }

    return (
        <div className="row">
            {
                props.text === "HUF" ?
                    <div className="col-12" ref={detailsRef}>
                        <h2 className="color-black e-inter-bold e-font-24 mb-2">
                            Add first applicant & coparcener details
                        </h2>
                        <p className="color-outer-space e-poppins-regular e-font-16 margin-32px-bottom">
                            Add karta & coparcener to start HUF investment and wealth management.
                        </p>
                        <div className="row" >
                            <h5 className="color-primary-color e-font-18 e-poppins-medium margin-2px-bottom">Karta details</h5>
                            <p className="color-outer-space e-poppins-regular e-font-14 mb-3">Add personal details</p>
                            <div className="col-lg-4 col-sm-6 col-12" >
                                <CustomTextInput label="Karta name"
                                    value={name}
                                    error={nameError}
                                    postfix="*"
                                    handleChange={_handleName} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12  mt-sm-0 pt-sm-0 mt-4 pt-3">
                                <CustomTextInput label="Karta PAN number"
                                    postfix="*"
                                    pan={true}
                                    value={panNumber}
                                    maxLength={10}
                                    error={panNumberError}
                                    handleChange={_handlePan} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12 mt-lg-0 pt-lg-0 mt-4 pt-3">
                                <DatePicker label="Date of Birth"
                                    error={dobError}
                                    maxDate={maxDate}
                                    value={dob}
                                    postFix="*"
                                    dob={_handleDob} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomTextInput value={mail}
                                    label="Email"
                                    type="text"
                                    error={mailError}
                                    postfix="*"
                                    handleChange={_handleMail}
                                    require />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomPhoneInput
                                    label="Mobile"
                                    postfix="*"
                                    error={phoneError}
                                    value={phone}
                                    type='number'
                                    handleChange={_handlePhone} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12 mt-4">
                                <p className="color-black e-font-14 e-poppins-medium mb-2">Upload PAN <span className='color-red'>*</span> </p>
                                {
                                    uploadedPan === null ?
                                        (
                                            <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                className="e-select-file"
                                                error={uploadedPanError}
                                                loading={fileLoader === 1 ? true : false}
                                                onSelectFile={_handlePanUpload} />
                                        ) : (
                                            <FilePreview fileName={uploadedPan}
                                                removeFile={() => {
                                                    setUploadedPan(null);
                                                    setPanUrl("")
                                                }} />
                                        )
                                }
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3" >
                                <CustomTextInput label="Karta father name"
                                    value={kartaFatherName}
                                    error={kartaFatherNameError}
                                    postfix="*"
                                    handleChange={_handleKartaFatherName} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3" >
                                <CustomTextInput label="Karta mother name"
                                    value={kartaMotherName}
                                    error={kartaMotherNameError}
                                    postfix="*"
                                    handleChange={_handleKartaMotherName} />
                            </div>

                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomSelectBox value={kartaOccupation}
                                    label="Karta occupation"
                                    postfix="*"
                                    error={kartaOccupationError}
                                    options={occupationList}
                                    isSearchable={false}
                                    onSelectChange={(e) => {
                                        setKartaOccupation(e);
                                        setKartaOccupationError("");
                                    }} />
                            </div>
                            {
                                kartaOccupation && kartaOccupation.value === 116 ? (
                                    <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3" >
                                        <CustomTextInput label="Karta other occuption"
                                            value={kartaOtherOccupation}
                                            error={kartaOtherOccupationError}
                                            postfix="*"
                                            handleChange={(value) => {
                                                setKartaOtherOccupation(value);
                                                setKartaOtherOccupationError("")
                                            }} />
                                    </div>
                                ) :
                                    null
                            }
                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomSelectBox value={kartaIncome}
                                    label="Karta Income"
                                    postfix="*"
                                    error={kartaIncomeError}
                                    options={incomeList}
                                    isSearchable={false}
                                    onSelectChange={(e) => {
                                        setKartaIncome(e);
                                        setkartaIncomeError("");
                                    }} />
                            </div>
                            <div className="col-lg-12 col-sm-6 col-12 mt-4 pt-3">
                                <p className="color-black e-poppins-medium e-font-14 mb-1">Karta gender</p>
                                <RadioGroup data={genderData}
                                    className={`gap-16px`}
                                    type={2}
                                    id={kartaGender}
                                    radioHandler={(id) => _handleKartaGender(id)} />
                            </div>
                            <div className="col-lg-12 col-sm-6 col-12 mt-4 pt-3">
                                <p className="color-black e-poppins-medium e-font-14 mb-1">Karta marital status</p>
                                <RadioGroup data={maritalData}
                                    className={`gap-16px`}
                                    type={2}
                                    id={kartaMaritalStatus}
                                    radioHandler={(id) => _handleKartaMaritalStatus(id)} />
                            </div>
                        </div>
                        <div className="row">
                            <p className="color-outer-space e-poppins-regular e-font-14 mb-3 mt-3">Add address details</p>
                            <div className="col-lg-4 col-sm-6 col-12">
                                <CustomTextInput value={addressLine1}
                                    label="Address 1"
                                    postfix="*"
                                    error={addressLine1Error}
                                    handleChange={(e) => { setAddressLine1(e); setAddressLine1Error('') }} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12  mt-sm-0 pt-sm-0 mt-4 pt-3">
                                <CustomTextInput value={addressLine2}
                                    label="Address 2"
                                    error={addressLine2Error}
                                    handleChange={(e) => { setAddressLine2(e); setAddressLine2Error('') }} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12  mt-lg-0 pt-lg-0 mt-4 pt-3">
                                <CustomTextInput value={addressLine3}
                                    label="Address 3"
                                    error={addressLine3Error}
                                    handleChange={(e) => { setAddressLine3(e); setAddressLine3Error('') }} />
                            </div>

                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomSelectBox value={addressCountry}
                                    label="Country"
                                    postfix="*"
                                    isSearchable={true}
                                    error={addressCountryError}
                                    options={countryOption}
                                    onSelectChange={(e) => {
                                        setAddressCountry(e);
                                        _getStates(e.value, 1);
                                        setAddressState(null);
                                        setAddressCity(null);
                                        setAddressCountryError("");
                                    }} />
                            </div>

                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomSelectBox value={addressState}
                                    label="State"
                                    postfix="*"
                                    error={addressStateError}
                                    options={stateOption}
                                    isSearchable={true}
                                    isDisabled={addressCountry === null ? true : false}
                                    onSelectChange={(e) => {
                                        setAddressState(e);
                                        _getCities(e.value, 1);
                                        setAddressCity(null);
                                        setAddressStateError("");
                                    }} />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomSelectBox value={addressCity}
                                    label="City"
                                    postfix="*"
                                    isDisabled={addressState === null ? true : false}
                                    error={addressCityError}
                                    options={cityOption}
                                    isSearchable={true}
                                    onSelectChange={(e) => {
                                        setAddressCity(e);
                                        setAddressCityError("");
                                    }} />
                            </div>

                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomTextInput value={pinCode}
                                    label="Pin code"
                                    postfix="*"
                                    type="number"
                                    error={pinCodeError}
                                    options={stateOption}
                                    maxLength={6}
                                    handleChange={(e) => {
                                        setPinCode(e);
                                        setPinCodeError('')
                                    }} />
                            </div>

                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                <CustomSelectBox value={addressProof}
                                    label="Select address proof type"
                                    postfix="*"
                                    options={addressProofOptions}
                                    error={addressProofError}
                                    onSelectChange={(e) => {
                                        setAddressProof(e);
                                        setAddressProofError("");
                                    }} />
                            </div>

                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-1">
                                <p className="color-black e-font-14 e-poppins-medium mb-2">Upload address proof<span className='color-red'>*</span> </p>

                                {
                                    addressUploadedProof === null ?
                                        <CustomFilePicker accept=".png, .pdf, .jpeg, .jpg"
                                            className="e-select-file"
                                            error={addressUploadedProofError}
                                            loading={fileLoader === 2 ? true : false}
                                            onSelectFile={(path, value) => _handleUploadFile(path, value)} />
                                        :
                                        <FilePreview fileName={addressUploadedProof}
                                            removeFile={() => {
                                                setAddressUploadedProof(null);
                                                setAddressProofUrl("")
                                            }} />
                                }

                            </div>
                        </div>

                        {
                            coparcenerDetails.map((item, index) => {
                                return (
                                    <div className="pt-4" ref={el => validationRef.current[index] = el}>
                                        <div className="row pt-2" >
                                            <h5 className="color-black e-font-18 e-poppins-medium margin-2px-bottom">Coparcener {index + 1} details
                                                {coparcenerDetails.length > 1 &&
                                                    <Icon icon="delete" size={24}
                                                        className="cursor-pointer ms-2"
                                                        onClick={() => _handleDelete(index)} />
                                                }
                                            </h5>
                                            <p className="color-outer-space e-poppins-regular e-font-14 mb-3">Add personal details</p>
                                            <div className="col-lg-4 col-sm-6 col-12">
                                                <CustomTextInput label="Applicant name"
                                                    value={item.name}
                                                    pan={true}
                                                    error={item.nameError}
                                                    postfix="*"
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "name", "nameError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-sm-0 pt-sm-0 mt-4 pt-3">
                                                <CustomTextInput label="Applicant PAN"
                                                    value={item.panNumber}
                                                    pan={true}
                                                    error={item.panNumberError}
                                                    maxLength={10}
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "panNumber", "panNumberError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-lg-0 pt-lg-0 mt-4 pt-3">
                                                <DatePicker label="Date of Birth"
                                                    error={item.dobError}
                                                    maxDate={new Date()}
                                                    value={item.dob}
                                                    dob={(date) => _handleCopencerDetails(date, index, "dob", "dobError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 pt-3 mt-3">
                                                <CustomTextInput value={item.mail}
                                                    label="Email"
                                                    type="text"
                                                    id={`coparcener_email${index}`}
                                                    error={item.mailError}
                                                    postfix="*"
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "mail", "mailError")}
                                                    require />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 pt-3 mt-3">
                                                <CustomPhoneInput
                                                    label="Mobile"
                                                    postfix="*"
                                                    id={`coparcener_mobile1${index}`}
                                                    error={item.phoneError}
                                                    value={item.phone}
                                                    type='number'
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "phone", "phoneError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12">
                                                <p className="color-black e-font-14 e-poppins-medium mb-2 mt-4">Upload PAN</p>
                                                {
                                                    item.uploadedPan === null ?
                                                        (
                                                            <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                                className="e-select-file"
                                                                error={item.uploadedPanError}
                                                                loading={fileLoader === `uploadedPan${index}` ? true : false}
                                                                onSelectFile={(path, file) => _handleCopencerFileUpload(path, file, index, "uploadedPan", "uploadedPanError", "panUrl")} />
                                                        ) : (
                                                            <FilePreview fileName={item.uploadedPan}
                                                                removeFile={() => _handleCopencerFileUpload("", null, index, "uploadedPan", "uploadedPanError", "panUrl")} />
                                                        )
                                                }
                                            </div>
                                            {/* Father input field */}
                                            <div className="col-lg-4 col-sm-6 col-12  mt-sm-3 pt-sm-3 mt-4 pt-3">
                                                <CustomTextInput label="Father name"
                                                    postfix="*"
                                                    id={`father_name${index}`}
                                                    value={item.fatherName}
                                                    error={item.fatherNameError}
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "fatherName", "fatherNameError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12  mt-sm-3 pt-sm-3 mt-4 pt-3">
                                                <CustomTextInput label="Mother name"
                                                    postfix="*"
                                                    id={`mother_name${index}`}
                                                    value={item.motherName}
                                                    error={item.motherNameError}
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "motherName", "motherNameError")} />
                                            </div>
                                            <div className="col-12 pt-3 mt-2">
                                                {/* Gender */}
                                                <p className="color-black e-poppins-medium e-font-14 mb-1">Gender</p>
                                                <RadioGroup data={genderData}
                                                    className={`gap-16px`}
                                                    type={2}
                                                    id={item.gender}
                                                    radioHandler={(id) => _handleCopencerDetails(id, index, "gender", "")} />
                                            </div>
                                            <div className="col-12 pt-3">
                                                {/* Marital status */}
                                                <p className="color-black e-poppins-medium e-font-14 mb-1">Marital status</p>
                                                <RadioGroup data={maritalData}
                                                    className={`gap-16px`}
                                                    type={2}
                                                    id={item.maritalStatus}
                                                    radioHandler={(id) => _handleCopencerDetails(id, index, "maritalStatus", "")} />
                                            </div>

                                            <p className="color-outer-space e-poppins-regular e-font-14 mb-3 mt-3">Add address details</p>
                                            <div className="col-lg-4 col-sm-6 col-12">
                                                <CustomTextInput value={item.addressLine1}
                                                    label="Address 1"
                                                    id={`coparcener_address1${index}`}
                                                    postfix="*"
                                                    error={item.addressLine1Error}
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "addressLine1", "addressLine1Error")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12  mt-sm-0 pt-sm-0 mt-4 pt-3">
                                                <CustomTextInput value={item.addressLine2}
                                                    label="Address 2"
                                                    id={`coparcener_address2${index}`}
                                                    error={item.addressLine2Error}
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "addressLine2", "addressLine2Error")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-lg-0 pt-lg-0 mt-4 pt-3">
                                                <CustomTextInput value={item.addressLine3}
                                                    label="Address 3"
                                                    id={`coparcener_address3${index}`}
                                                    error={item.addressLine3Error}
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "addressLine3", "addressLine3Error")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                                <CustomSelectBox value={item.addressCountry}
                                                    label="Country"
                                                    isSearchable={true}
                                                    error={item.addressCountryError}
                                                    options={countryOption}
                                                    onSelectChange={(input_value) => {
                                                        _handleCopencerDetails(input_value, index, "addressCountry", "addressCountryError");
                                                        _handleCopencerDetails(null, index, "addressState", "addressStateError");
                                                        _handleCopencerDetails(null, index, "addressCity", "addressCityError");
                                                        _getStates(input_value.value, 2);
                                                    }} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                                <CustomSelectBox value={item.addressState}
                                                    label="State"
                                                    postfix="*"
                                                    error={item.addressStateError}
                                                    isSearchable={true}
                                                    options={stateOption1}
                                                    isDisabled={item.addressCountry === null ? true : false}
                                                    onSelectChange={(input_value) => {
                                                        _handleCopencerDetails(input_value, index, "addressState", "addressStateError");
                                                        _handleCopencerDetails(null, index, "addressCity", "addressCityError");
                                                        _getCities(input_value.value, 2)
                                                    }} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                                <CustomSelectBox value={item.addressCity}
                                                    label="City"
                                                    postfix="*"
                                                    error={item.addressCityError}
                                                    isSearchable={true}
                                                    isDisabled={item.addressState === null ? true : false}
                                                    options={cityOption1}
                                                    onSelectChange={(input_value) => _handleCopencerDetails(input_value, index, "addressCity", "addressCityError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                                <CustomTextInput value={item.pinCode}
                                                    label="Pin code"
                                                    postfix="*"
                                                    type="number"
                                                    id={`coparcener_pincode${index}`}
                                                    error={item.pinCodeError}
                                                    maxLength={6}
                                                    handleChange={(input_value) => _handleCopencerDetails(input_value, index, "pinCode", "pinCodeError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-3">
                                                <CustomSelectBox value={item.addressProof}
                                                    label="Select address proof type"
                                                    postfix="*"
                                                    error={item.addressProofError}
                                                    options={addressProofOptions}
                                                    onSelectChange={(input_value) => _handleCopencerDetails(input_value, index, "addressProof", "addressProofError")} />
                                            </div>
                                            <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-1">
                                                <p className="color-black e-font-14 e-poppins-medium mb-2">Upload address proof<span className='color-red'>*</span> </p>

                                                {
                                                    item.addressUploadedProof === null ?
                                                        <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                            className="e-select-file"
                                                            error={item.addressUploadedProofError}
                                                            loading={fileLoader === `addressUploadedProof${index}` ? true : false}
                                                            onSelectFile={(path, file) => _handleCopencerFileUpload(path, file, index, "addressUploadedProof", "uploadedPanError", "addressProofUrl")} />
                                                        :
                                                        <FilePreview fileName={item.addressUploadedProof}
                                                            removeFile={() => _handleCopencerFileUpload("", null, index, "addressUploadedProof", "addressUploadedProofError", "addressProofUrl")} />
                                                }

                                            </div>

                                        </div>
                                    </div>
                                )
                            })
                        }
                        <OutlineButton label="Add new co-pacarcner"
                            prefix="add"
                            iconSize={24}
                            iconClass="ms-2 me-2"
                            className="padding-12px-tb margin-50px-top"
                            handleClick={_handleAddDetails} />
                        {/* <div className="row">
                        </div> */}
                        <div className="margin-32px-top">
                            {/* validation */}
                            <GradientButton label="Submit"
                                className="padding-12px-tb px-3 e-font-16"
                                loading={btnLoader}
                                handleClick={_handleValidation} />
                        </div>
                    </div>
                    :
                    loader === true ?
                        <CustomLoader />
                        :
                        kycCompleted === false ?
                            <Fragment>
                                {
                                    kycCompleteData.address.length !== 0 ?
                                        <div className="col-lg-7 col-md-7 col-12">
                                            <h2 className="color-black e-inter-bold e-font-24-sm-18 mb-2">
                                                You are not a KYC verified user
                                            </h2>
                                            <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px mb-4">
                                                Please verify the below details from Digilocker
                                            </p>
                                            <div className="border-radius-16px border-all border-primary-color bg-pale-cyan p-3">
                                                <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-2">Aadhar number : {kycCompleteData.aadhaar}</p>
                                                <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-2">Name : {kycCompleteData.name}</p>
                                                <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-2">Address : {kycCompleteData.address}</p>
                                                <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-0">Nationality : {kycCompleteData.nationality === true ? "Indian" : null}</p>
                                            </div>
                                            <RadioGroup data={KYC_DATA}
                                                className={`gap-24px flex-wrap mt-3`}
                                                radioItem="w-unset"
                                                iconClassName="me-2"
                                                type={1}
                                                id={selected_kyc}
                                                radioHandler={_handleRadioInput} />
                                            {
                                                isAddressUpdated === true &&
                                                <div className='e-warning-info-wrapper d-flex align-items-center mt-3'>
                                                    <p className='mb-0 e-poppins-regular line-height-20px e-font-11 mb-0'>
                                                        You have successfully fetched updated address from Digilocker. Click Proceed to continue KYC registration.
                                                    </p>
                                                </div>
                                            }

                                            <GradientButton label="Proceed"
                                                loading={apiLoader}
                                                className="padding-14px-tb padding-16px-lr e-font-16 mt-sm-5 mt-3 mb-sm-0 mb-3 mob-w-100"
                                                handleClick={_handleProceed} />

                                        </div>
                                        :
                                        <div className="row">
                                            <div className="col-lg-7 col-md-7 col-12">
                                                <h2 className="color-black e-inter-bold e-font-24-sm-18">
                                                    Fetch your identity using DigiLocker
                                                </h2>
                                                <p className="color-outer-space e-poppins-regular e-font-sm-16-14 mt-3">
                                                    You are not KYC registered user. In order to invest you needs to registered with KRA.
                                                    It may take few seconds.
                                                </p>

                                                {/* Card notes */}
                                                <div className="bg-beige border-radius-16px p-3">
                                                    <h6 className="color-black e-poppins-medium e-font-14-sm-12">*Note</h6>
                                                    <div className="d-flex color-outer-space e-poppins-regular e-font-14-sm-12 ms-2">
                                                        <p>1.</p>
                                                        <p className="line-height-20px margin-block-end-0">
                                                            If you do not have a Digilocker account, you can still proceed with your Aadhaar and
                                                            it will be created during the process.
                                                        </p>
                                                    </div>
                                                    <div className="d-flex color-outer-space e-poppins-regular e-font-14-sm-12 margin-block-end-0 mt-2 ms-2">
                                                        <p className="margin-block-end-0">2. </p>
                                                        <p className="line-height-20px margin-block-end-0">
                                                            We will be fetching both PAN and Aadhaar from Digilocker which may take a few seconds.
                                                        </p>
                                                    </div>
                                                </div>
                                                <GradientButton label="Continue with digilocker"
                                                    loading={apiLoader}
                                                    className="padding-14px-tb padding-16px-lr e-font-16 mt-sm-5 mt-3 mb-sm-0 mb-3 mob-w-100"
                                                    handleClick={() => {
                                                        // props.updateProgress(4);
                                                        _getAddressFromAadhar()
                                                    }
                                                    } />
                                            </div>
                                            <div className="col-4 offset-lg-1 mt-5 d-lg-block d-md-block d-none">
                                                <img src={require('../../../Assets/Images/kyc/fetch-kyc.png')}
                                                    draggable={false}
                                                    alt="" />
                                            </div>
                                        </div>
                                }
                            </Fragment>
                            :
                            <Fragment>
                                <div className="col-lg-7 col-md-7 col-12">
                                    <h2 className="color-black e-inter-bold e-font-24-sm-18 mb-2">
                                        You are already a registered KYC user
                                    </h2>
                                    <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px mb-sm-4 mb-3">
                                        Please verify the below details from KYC Registration Agency (KRA).
                                    </p>
                                    <div className="border-radius-16px border-all border-primary-color bg-pale-cyan p-3">
                                        <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-2">Aadhar number : {kycCompleteData.aadhaar}</p>
                                        <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-2">Name : {kycCompleteData.name}</p>
                                        <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-2 word-break-all">Address : {kycCompleteData.address}</p>
                                        <p className="e-kyc-address-text e-poppins-regular e-font-sm-16-14 mb-0">Nationality : {kycCompleteData.nationality === true ? "Indian" : null}</p>
                                    </div>

                                    <RadioGroup data={KYC_DATA}
                                        className={`gap-24px flex-wrap mt-3`}
                                        radioItem="w-unset"
                                        iconClassName="me-2"
                                        type={1}
                                        id={selected_kyc}
                                        radioHandler={_handleRadioInput} />
                                    {
                                        isAddressUpdated === true &&
                                        <div className='e-warning-info-wrapper d-flex align-items-center mt-3'>
                                            <p className='mb-0 e-poppins-regular line-height-20px e-font-11 mb-0'>
                                                You have successfully fetched updated address from Digilocker. Click Proceed to continue KYC registration.
                                            </p>
                                        </div>
                                    }

                                    <GradientButton label="Proceed"
                                        loading={apiLoader}
                                        className="padding-14px-tb padding-16px-lr e-font-16 mt-sm-5 mt-3 mb-sm-0 mb-3 mob-w-100"
                                        handleClick={_handleProceed} />


                                </div>
                            </Fragment>

            }

        </div >
    )
}